import { markdown } from 'markdown';
import { sanitize } from 'isomorphic-dompurify';
import { classnames } from '@/utils/classnames/classnames';
import { MarkdownProps } from './types';

const Markdown = ({ children, className, targetBlank }: MarkdownProps) => {
  const content = children ?? '';
  const hasHtmlTags = /<[^>]+>/.test(content);
  const html = hasHtmlTags ? content : markdown.toHTML(content);

  let dangerousHtml = html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, "'");

  if (targetBlank) {
    dangerousHtml = dangerousHtml.replace(/<a\b([^>]*)/g, (match, p1) => {
      if (!/target=/i.test(p1)) {
        return `<a target="_blank" rel="noopener noreferrer"${p1}`;
      }
      return match;
    });
  }

  const sanitizedHtml = sanitize(dangerousHtml, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: targetBlank ? ['target', 'rel'] : [],
  });


  return (
    <p className={classnames('whitespace-pre-wrap', className)} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

export default Markdown;
